import axiosInstance from "@/lib/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";


export interface CaseWorkflowStagesResponse {
    success: boolean;
    data: {
        workflow_status: []
    };
    message?: string;
    total?: number;
}

export interface AssignedUsersData {
    success: boolean;
    data: [];
    message?: string;
}

export const fetchCaseWorkflowStages = createAsyncThunk<
    CaseWorkflowStagesResponse,
    number,
    { rejectValue: string }
>(
    'caseWorkflowStages/fetch',
    async (caseId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `/workflow/status/${caseId}`,
                {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                    },
                }
            );

            return response.data
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch case workflow stages');
        }
    }
);

export const fetchAssignedUsers = createAsyncThunk<
    AssignedUsersData,
    number,
    { rejectValue: string }
>(
    'assignedUsers/fetch',
    async (workflowId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `/workflow/assigned-users/${workflowId}`,
                {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                    },
                }
            );

            return response.data
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch assigned users');
        }
    }
);
